import React, { Component, Fragment } from "react";
import { Form, FormGroup, Label, Input, FormText } from "reactstrap";

import Section from "./../Section/Section";
import SectionTitle from "./../SectionTitle/SectionTitle";

const SectionForm = (props) => {
  return (
    <Section style={{ ...props.sectionStyle, height: "auto" }}>
      <SectionTitle colors={props.colors}>{props.title}</SectionTitle>
      <Form onSubmit={props.onSubmit} style={props.formStyle}>
        {props.children}
      </Form>
    </Section>
  );
};

export default SectionForm;
